const UserList = () => {
  return <>Lista</>;
};

export default UserList;
